
import {Box} from "@mui/material";
import React, {useMemo} from "react";
import {ShortAnswer} from "../../../../components/ShortAnswer";

export const BmiInput = ({
  heightCm,
  weightKg,
  onChangeHeightCm,
  onChangeWeightKg,
}) => {

  const bmi = useMemo(() => {
    const height = parseFloat(heightCm);
    const weight = parseFloat(weightKg);

    if (!height || !weight) return null;

    const heightMeter = height / 100;
    const value = weight / (heightMeter * heightMeter);

    return Number(value.toFixed(1));
  }, [heightCm, weightKg]);

  const bmiLabel = useMemo(() => {
    let label = '';
    if (bmi < 18.5) {
      label = '過輕';
    } else if (bmi < 24) {
      label = '正常';
    } else if (bmi < 27) {
      label = '過重';
    } else if (bmi < 30) {
      label = '輕度肥胖';
    } else if (bmi < 35) {
      label = '中度肥胖';
    } else {
      label = '重度肥胖';
    }
    return label
  }, [bmi])

  return (
    <Box className="flex space-between items-center gap-4">
      <ShortAnswer
        type="number"
        className="flex-1"
        value={heightCm}
        onChange={e => onChangeHeightCm(e.target.value)}
        placeholder="身高(公分)"
      />
      <ShortAnswer
        type="number"
        className="flex-1"
        value={weightKg}
        onChange={e => onChangeWeightKg(e.target.value)}
        placeholder="體重(公斤)"
      />
      <div className="flex-1 text-sm">
        {bmi ? `BMI: ${bmi} (${bmiLabel})` : ''}
      </div>
    </Box>
  )
}